import { useEffect, useState } from "react";

export const useIsInitialRender = () => {
  const [initial, setInitial] = useState(true);
  useEffect(() => {
    setInitial(false);
  }, []);
  return initial;
};
